export const convertImage = async (file, format) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const image = new Image();
      image.src = event.target.result;
      image.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0);
        canvas.toBlob((blob) => {
          resolve(blob);
        }, `image/${format}`);
      };
    };
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};
